import { Action, createAction, props } from '@ngrx/store'
import { NavigationExtras } from '@angular/router'
import { LoadingStateType } from '@adex/shared/models/states/loading.state'
import { HttpErrorResponse } from '@angular/common/http'
import { IStorageState } from '@adex/shared/models/states/storage.state'
import { IFile } from '@adex/shared/models/file'
import { GtmEvents } from '@adex/shared/models/gtm-events'


export const empty = createAction(
  '[Global] Empty'
)

export const navigate = createAction(
  '[Global] Navigate',
  props<{ commands: string | string[], extras?: NavigationExtras }>()
)

export const unauthorizedUser = createAction(
  '[Global] Unauthorized User'
)

export const setLoadingState = createAction(
  '[Global] Set Loading State',
  props<{ url: string, state: LoadingStateType, error?: HttpErrorResponse }>()
)

export const alertError = createAction(
  '[Global] Alert Error',
  props<{ message: string }>()
)

export const notificationMessage = createAction(
  '[Global] Notification Message',
  props<{ message: string }>()
)

export const notificationWarning = createAction(
  '[Global] Notification Warning',
  props<{ message: string }>()
)

export const initStorageState = createAction(
  '[Global] Init Storage State',
  props<{ state: IStorageState }>()
)

export const setStorageValue = createAction(
  '[Global] Set Storage Value',
  props<{ key: keyof IStorageState, value: Partial<IStorageState[ keyof IStorageState]> }>()
)

export const setStorageStateValue = createAction(
  '[Global] Set Storage State Value',
  props<{ key: keyof IStorageState, value: Partial<IStorageState[ keyof IStorageState]> }>()
)

export const deleteStorageValue = createAction(
  '[Global] Delete Storage Value',
  props<{ key: keyof IStorageState }>()
)

type patchStorageValueType<K extends keyof IStorageState, V = Partial<IStorageState[ K ]>, S = IStorageState[K]> = {
  key: K
  value?: V
  patcher: (state: any, value?: V) => Partial<S>
}
export const patchStorageValue = createAction(
  '[Global] Patch Storage Value',
  props<patchStorageValueType<keyof IStorageState>>()
)

export const saveFile = createAction(
  '[Global] Save File',
  props<{ file: IFile }>()
)

export const openConfirmModal = createAction(
  '[Global] Open Confirm Modal',
  props<{ action: () => Action, translateObjectName?: string }>()
)

export const copyToClipboard = createAction(
  '[Global] Copy To Clipboard',
  props<{ content: string }>()
)

export const sendGTMEvent = createAction(
  '[Global] Send GTM Event',
  props<{ event: GtmEvents }>()
)
